import { render, staticRenderFns } from "./memberHomeNew.vue?vue&type=template&id=cd31af72&scoped=true"
import script from "./memberHomeNew.vue?vue&type=script&lang=js"
export * from "./memberHomeNew.vue?vue&type=script&lang=js"
import style0 from "./memberHomeNew.vue?vue&type=style&index=0&id=cd31af72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd31af72",
  null
  
)

export default component.exports